import { render, staticRenderFns } from "./userdatawizard.vue?vue&type=template&id=36acd356&scoped=true"
import script from "./userdatawizard.vue?vue&type=script&lang=js"
export * from "./userdatawizard.vue?vue&type=script&lang=js"
import style0 from "./userdatawizard.vue?vue&type=style&index=0&id=36acd356&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36acd356",
  null
  
)

export default component.exports